module.exports = __webpack_public_path__ + "static/media/file-collect.2c1a814a.svg";